















































import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { EPLModule } from '@/store/eplmodule'

@Component({
  name: 'Dict',
  components: {
    DictTable: () =>
      import(/* webpackChunkName: "DictTable" */ '@/components/DictTable.vue')
  }
})
export default class Dict extends Vue {
  @Prop() dictName!: string

  tableKey = 0
  idx = -1
  syncMsg = ''
  showSyncMsg = false
  colorSyncMsg = 'primary'
  listHeight = '500px'

  dicts = {
    Settings: { icon: 'fas fa-cog' },
    AccessTable: { icon: 'fas fa-lock' },
    Organizations: { icon: 'fas fa-industry' },
    Roles: { icon: 'fas fa-user-tag' },
    Users: { icon: 'fas fa-users' },
    Drivers: { icon: 'fas fa-user-tie' },
    TransportType: { icon: 'fas fa-tractor' },
    CargoType: { icon: 'fas fa-dolly-flatbed' },
    Transport: { icon: 'fas fa-car' },
    FuelType: { icon: 'fas fa-gas-pump' },
    DowntimeType: { icon: 'fas fa-pause' },
    CheckListLines: { icon: 'fas fa-receipt' },
    ReportsList: { icon: 'fas fa-file-alt' },
    ServiceNames: { icon: 'fas fa-concierge-bell' },
    CarType: { icon: 'fas fa-balance-scale' },
    // EPLjournal: { icon: 'fas fa-book' },
    // ADtoUIDlist: { icon: 'fas fa-ad' },
    ObjKS: { icon: 'fas fa-building' },
    PassengerRoutes: { icon: 'fas fa-bus-alt' },
    GraphWork: { icon: 'fas fa-calendar-alt' },
    ActionJournal: { icon: 'fas fa-users-cog' },
    Routes: { icon: 'fas fa-route' }
    // GalaxyReqList: { icon: 'fab fa-galactic-senate' }
  }

  @Watch('dictName')
  onDictNameChange () {
    this.tableKey++
    EPLModule.hideDictForm(this.idx)
    this.idx = EPLModule.DictIdx(this.dictName)
  }

  async mounted () {
    this.idx = EPLModule.DictIdx(this.dictName)
    this.reSize()
    window.addEventListener('resize', this.reSize)
  }

  get Dicts () {
    return EPLModule.Dicts
  }

  get user () {
    return EPLModule.user
  }

  private reSize () {
    const k = 186
    this.listHeight = `${window.innerHeight - k}px`
  }

  private clickRow (id: number) {
    if (EPLModule.dicts[this.idx].name === 'EPL') {
      this.$router.push(`${this.$router.currentRoute.path}/${id}`)
    } else {
      EPLModule.showDictForm({ id: id, idx: this.idx })
    }
  }

  private sync () {
    EPLModule.syncGalaxyDic()
      .then((resp: any) => {
        if (resp.data === 'STARTED') {
          this.colorSyncMsg = 'primary'
          this.syncMsg = 'Синхронизация запущена'
          this.showSyncMsg = true
        }
        if (resp.data === 'IN PROGRESS') {
          this.colorSyncMsg = 'error'
          this.syncMsg = 'Синхронизация не завершена'
          this.showSyncMsg = true
        }
      })
  }
}
